var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.events.length > 1)?_c('div',{attrs:{"id":"event-selector"}},[_c('v-select',{attrs:{"items":_vm.events,"item-text":"name","item-value":"id","label":"Event"},on:{"change":_vm.change},model:{value:(_vm.eventId),callback:function ($$v) {_vm.eventId=$$v},expression:"eventId"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }